<template>
  <div>
    <div v-if="fareFeatures">
      <v-layout
        v-for="(feature, index) in fareFeatures.features"
        :key="index"
        justify-center
        style="text-align: center; padding: 6px"
      >
        {{ feature }}
      </v-layout>
    </div>
    <div v-else>
      <v-layout justify-center style="text-align: center; padding: 6px">
        Fare bilgisi bulunamadı
      </v-layout>
    </div>
  </div>
</template>

<script>
export default {
  name: "PegasusFareFeatures",
  props: {
    fareName: {
      type: String,
      required: true,
    },
    flightType: {
      type: String,
      default: "domestic", // domestic, international, cyprus
    },
  },
  data() {
    return {
      pegasusFares: {
        "LIGHT": {
          domestic: {
            features: [
              "1 Adet Kişisel Eşya (40x30x15 cm, Max 3 kg)",
              "Kabin Bagajı Yok",
              "Uçak Altı Bagajı Yok",
            ],
          },
          international: {
            features: [
              "1 Adet Kişisel Eşya (40x30x15 cm, Max 3 kg)",
              "Kabin Bagajı Yok",
              "Uçak Altı Bagajı Yok",
            ],
          },
        },
        "SÜPER EKO": {
          domestic: {
            features: [
              "1 Adet Kişisel Eşya (40x30x15 cm, Max 3 kg)",
              "15 kg Uçak Altı Bagajı",
            ],
          },
          international: {
            features: [
              "1 Adet Kabin Bagajı (55x40x20 cm, Max 8 kg)",
              "1 Adet Kişisel Eşya (40x30x15 cm, Max 3 kg)",
              "20 kg Uçak Altı Bagajı",
            ],
          },
          cyprus: {
            features: [
              "1 Adet Kabin Bagajı (55x40x20 cm, Max 8 kg)",
              "1 Adet Kişisel Eşya (40x30x15 cm, Max 3 kg)",
              "20 kg Uçak Altı Bagajı",
            ],
          },
        },
        "AVANTAJ": {
          domestic: {
            features: [
              "1 Adet Kabin Bagajı (55x40x20 cm, Max 8 kg)",
              "1 Adet Kişisel Eşya (40x30x15 cm, Max 3 kg)",
              "20 kg Uçak Altı Bagajı",
              "Standart Koltuk Seçimi",
              "Sandviç İkramı",
              "Fly&Watch Uçak İçi Eğlence",
            ],
          },
          international: {
            features: [
              "1 Adet Kabin Bagajı (55x40x20 cm, Max 8 kg)",
              "1 Adet Kişisel Eşya (40x30x15 cm, Max 3 kg)",
              "20 kg Uçak Altı Bagajı",
              "Standart Koltuk Seçimi",
              "Sandviç İkramı",
              "Fly&Watch Uçak İçi Eğlence",
            ],
          },
        },
        "COMFORT FLEX": {
          domestic: {
            features: [
              "1 Adet Kabin Bagajı (55x40x20 cm, Max 8 kg)",
              "1 Adet Kişisel Eşya (40x30x15 cm, Max 3 kg)",
              "20 kg Uçak Altı Bagajı",
              "Dilediğiniz Koltuk Seçimi (Ekstra Bacak Aralığı Dahil)",
              "Esnek İade / Değişim Hakkı",
              "Sandviç İkramı",
              "Fly&Watch Uçak İçi Eğlence",
            ],
          },
          international: {
            features: [
              "1 Adet Kabin Bagajı (55x40x20 cm, Max 8 kg)",
              "1 Adet Kişisel Eşya (40x30x15 cm, Max 3 kg)",
              "20 kg Uçak Altı Bagajı",
              "Dilediğiniz Koltuk Seçimi (Ekstra Bacak Aralığı Dahil)",
              "Esnek İade / Değişim Hakkı",
              "Sandviç İkramı",
              "Fly&Watch Uçak İçi Eğlence",
            ],
          },
        },
      },
    };
  },
  computed: {
    fareFeatures() {
      const normalizedFareName = this.fareName
        ? this.fareName.toUpperCase().trim()
        : '';

      if (!normalizedFareName || !this.pegasusFares[normalizedFareName]) {
        return null;
      }

      const fare = this.pegasusFares[normalizedFareName];

      // Cyprus is considered as international for SÜPER EKO
      if (this.flightType === "cyprus" && fare.cyprus) {
        return fare.cyprus;
      }

      // Check if flight type specific data exists
      if (fare[this.flightType]) {
        return fare[this.flightType];
      }

      // Fallback to domestic if no specific type found
      return fare.domestic || fare.international || null;
    },
  },
};
</script>

<style scoped>
</style>
